import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useLocation, useHistory } from "react-router-dom";
import { parse, stringify } from '../../../../utils/UrlUtil';

const ExecutiveReportSurveyListHeader = () => {
  const history = useHistory();
  const location = useLocation();

  const params = parse(location.search);

  const [filter, setFilter] = useState({ ...params.filter });

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  const onQueryVariableChange = () => {
    const params = parse(location.search);

    // build the filter
    const newFilter = {
      ...params.filter,
      ...filter,
    };

    const search = stringify({
      ...params,
      filter: newFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  };

  /**
   * Update the filter Query.
   */
  const onChangeQueryText = (event) => {
    const updatedFilter = {
      ...filter,
      query: event.currentTarget.value,
    };

    setFilter(updatedFilter);
  };

  return (
    <div className="p-inputgroup">
      <InputText value={filter.query} onChange={onChangeQueryText} />
      <Button
        icon="pi pi-search"
        // For search we have a search button.
        // The state is already updated. We just upate the url
        onClick={onQueryVariableChange}
      />
    </div>
  );
};

export default ExecutiveReportSurveyListHeader;
